/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Environment } from '../models/environment';
import { EnvironmentRequest } from '../models/environment-request';

/**
 * Ui Environment Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiEnvironmentControllerService extends __BaseService {
  static readonly createEnvironmentUsingPOSTPath = '/cc-ui/v1/environments';
  static readonly configureDraftEnvironmentUsingPOSTPath =
    '/cc-ui/v1/environments/configure/{environmentId}';
  static readonly getEnvironmentUsingGET1Path =
    '/cc-ui/v1/environments/{environmentId}';
  static readonly updateEnvironmentUsingPUTPath =
    '/cc-ui/v1/environments/{environmentId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * createEnvironment
   * @param request request
   * @return OK
   */
  createEnvironmentUsingPOSTResponse(
    request: EnvironmentRequest,
  ): __Observable<__StrictHttpResponse<Environment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/environments`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Environment>;
      }),
    );
  }
  /**
   * createEnvironment
   * @param request request
   * @return OK
   */
  createEnvironmentUsingPOST(
    request: EnvironmentRequest,
  ): __Observable<Environment> {
    return this.createEnvironmentUsingPOSTResponse(request).pipe(
      __map((_r) => _r.body as Environment),
    );
  }

  /**
   * configureDraftEnvironment
   * @param params The `UiEnvironmentControllerService.ConfigureDraftEnvironmentUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `environmentId`: environmentId
   *
   * @return OK
   */
  configureDraftEnvironmentUsingPOSTResponse(
    params: UiEnvironmentControllerService.ConfigureDraftEnvironmentUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Environment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/environments/configure/${encodeURIComponent(
          String(params.environmentId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Environment>;
      }),
    );
  }
  /**
   * configureDraftEnvironment
   * @param params The `UiEnvironmentControllerService.ConfigureDraftEnvironmentUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `environmentId`: environmentId
   *
   * @return OK
   */
  configureDraftEnvironmentUsingPOST(
    params: UiEnvironmentControllerService.ConfigureDraftEnvironmentUsingPOSTParams,
  ): __Observable<Environment> {
    return this.configureDraftEnvironmentUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Environment),
    );
  }

  /**
   * getEnvironment
   * @param environmentId environmentId
   * @return OK
   */
  getEnvironmentUsingGET1Response(
    environmentId: string,
  ): __Observable<__StrictHttpResponse<Environment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/environments/${encodeURIComponent(String(environmentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Environment>;
      }),
    );
  }
  /**
   * getEnvironment
   * @param environmentId environmentId
   * @return OK
   */
  getEnvironmentUsingGET1(environmentId: string): __Observable<Environment> {
    return this.getEnvironmentUsingGET1Response(environmentId).pipe(
      __map((_r) => _r.body as Environment),
    );
  }

  /**
   * updateEnvironment
   * @param params The `UiEnvironmentControllerService.UpdateEnvironmentUsingPUTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `environmentId`: environmentId
   *
   * @return OK
   */
  updateEnvironmentUsingPUTResponse(
    params: UiEnvironmentControllerService.UpdateEnvironmentUsingPUTParams,
  ): __Observable<__StrictHttpResponse<Environment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/environments/${encodeURIComponent(
          String(params.environmentId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Environment>;
      }),
    );
  }
  /**
   * updateEnvironment
   * @param params The `UiEnvironmentControllerService.UpdateEnvironmentUsingPUTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `environmentId`: environmentId
   *
   * @return OK
   */
  updateEnvironmentUsingPUT(
    params: UiEnvironmentControllerService.UpdateEnvironmentUsingPUTParams,
  ): __Observable<Environment> {
    return this.updateEnvironmentUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as Environment),
    );
  }
}

module UiEnvironmentControllerService {
  /**
   * Parameters for configureDraftEnvironmentUsingPOST
   */
  export interface ConfigureDraftEnvironmentUsingPOSTParams {
    /**
     * request
     */
    request: EnvironmentRequest;

    /**
     * environmentId
     */
    environmentId: string;
  }

  /**
   * Parameters for updateEnvironmentUsingPUT
   */
  export interface UpdateEnvironmentUsingPUTParams {
    /**
     * request
     */
    request: EnvironmentRequest;

    /**
     * environmentId
     */
    environmentId: string;
  }
}

export { UiEnvironmentControllerService };
